import React, { useState } from 'react';
import { Modal, Button, Image, Form } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import greatIcon from '../assets/img/greatIcon.svg'
import logoicon from '../assets/img/logoicon.svg'
import { COMPANY_NAME } from '../constants/company'
const ThankyouModal = ({ Thankyou, ThankyouToggle }) => {

    return (
        <>
            <Modal show={Thankyou} onHide={ThankyouToggle} centered className='modal-getstarted modalnext'>
                <button type="button" className="rs-lc-close" onClick={ThankyouToggle} aria-label="Close">
                    <Icon icon="tabler:x" width={22} height={22} />
                </button>
                <Modal.Body className='ThanyouModal text-center rs-lc-body'>
                    <h5 className='logoColor'>
                        <Image src={logoicon} className="img-fluid" alt="" /> {COMPANY_NAME.toUpperCase()}
                    </h5>
                    <Image className='greatIcon' src={greatIcon} alt='' />
                    <h3>Thankyou for Submission</h3>
                    {/* <p>Thank you for sharing the details of your project. We are working on your Rapid Estimate.</p> */}
                    <p>Thank you for sharing the details of your project. We are working on your Rapid Estimate and you will receive a confirmation email shortly.</p>
                    <Button
                        type="button"
                        onClick={() => {
                            ThankyouToggle();
                            window.location.reload();
                        }}
                    >Done <Icon icon="mynaui:arrow-right" width="24" height="24" /></Button>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ThankyouModal;
